<template>
    <div>
        <Dialog v-bind:value="value" @input="$emit('input', $event)"
                title="Domain löschen ?"
                :loading="loading"
                @ok="submit" ok-text="Löschen"
                @cancel="$emit('input', false)">
            Soll die Domain <b>{{ domainName }}</b>
            wirklich gelöscht werden?
        </Dialog>
        <Snackbar v-model="successSnackbar" color="success">Domain <b> {{ domainName }} </b> erfolgreich gelöscht.
        </Snackbar>
    </div>
</template>

<script>
import Dialog from "../../../components/Dialog";
import Snackbar from "../../../components/Snackbar";

export default {
    name: "DeleteDomainDialog",
    components: {Snackbar, Dialog},
    props: ['value', 'domain'],
    data: () => {
        return {
            name: null,
            successSnackbar: false,
            loading: false,
        }
    },
    computed: {
        domainName() {
            return this.domain ? this.domain.Domain : null;
        },
        siteDetails() {
            return this.$store.state.display.siteDetails;
        },
    },
    methods: {
        async submit() {
            this.loading = true;
            let data;
            try {
                data = await this.$store.dispatch('display/deleteDomain', this.getBody());
                this.loading = false;
                if (data.Status) {
                    this.successSnackbar = true;
                    this.$emit('input', false); // set v-model to false -> close dialog
                    this.$emit('deleted');
                }
            } catch (e) {
                this.loading = false;
            }
        },
        getBody() {
            return {
                publisher_id: this.siteDetails.Site.PublisherId,
                site_id: this.siteDetails.Site.SiteId,
                type_id: this.siteDetails.Current.SitetypeId,
                domain: this.name,
                domain_id: this.domain.SitetypeDomainId
            }
        }
    },
}
</script>

<style scoped>

</style>